import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Global error handler — catches all unhandled errors across the application.
 *
 * Provides structured logging for observability and prevents unhandled
 * errors from silently failing in production.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    // HTTP errors are already handled by the error interceptor
    if (error instanceof HttpErrorResponse) {
      return;
    }

    const errorContext = {
      type: 'unhandled',
      timestamp: new Date().toISOString(),
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
    };

    console.error('[GlobalErrorHandler]', errorContext);
  }
}
